module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/emma-fox-484e44018e963720bca87144c613839c.jpg";